import { TabView, TabPanel } from "primereact/tabview";
import React, { useState, useEffect, useRef } from "react";
import yerlembg from "../images/yerlemicon.svg";
import { Button } from "primereact/button";
import { API_PORT, API_IP } from "./AppConfig/AppConfig";
import { useLocation } from "react-router-dom";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

export default function AdminPage({ setSidebarVisible }) {
  const AYD_API_IP = "78.186.223.18";
  const AYD_API_PORT = "7079";

  const toast = useRef(null);

  const showSuccess = () => {
    toast.current.show({
      severity: "success",
      summary: "Başarılı",
      detail: "Kullanıcı ekleme işlemi başarılı.",
      life: 3000,
    });
  };
  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "Hata",
      detail:
        "Kullanıcı ekleme işlemi hatalı. Lütfen tüm alanları doldurduğunuzdan emin olun",
      life: 3000,
    });
  };

  const [userYerlemId, setUserYerlemId] = useState(null);
  const [userFirstName, setUserFirstName] = useState(null);
  const [userLastName, setUserLastName] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [userPassword, setUserPassword] = useState(null);
  const [userTwoFactorAuthentication, setUserTwoFactorAuthentication] =
    useState(false);
  const [userGSM, setUserGSM] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [appToken, setAppToken] = useState(null);

  const handleAddUserButtonClick = async () => {
    // Cep telefonu numarasından sadece rakamları alarak formattedGSM'e atama yapılıyor.
    const formattedGSM = userGSM !== null ? userGSM.replace(/\D/g, "") : null;
    // Kullanıcı kaydı için gerekli veriler data nesnesine atanıyor.
    const data = {
      yerlemId: userYerlemId, // Kullanıcının yerlemId'si
      appInstance: location.state?.selectedInstanceId, // Seçilen uygulama örneği ID'si, varsa atanıyor.
      email: userEmail + "@yerlem.com", // Kullanıcının e-posta adresi yerlem.com ile birleştirilerek oluşturuluyor.
      gsm: formattedGSM, // Kullanıcının cep telefonu numarası, önceki adımda biçimlendirilerek atanıyor.
      password: userPassword, // Kullanıcının şifresi
      twoFactorAuthentication: userTwoFactorAuthentication, // İki faktörlü kimlik doğrulama durumu
      firstname: userFirstName, // Kullanıcının adı
      lastname: userLastName, // Kullanıcının soyadı
      roleIds: userRole, // Kullanıcının rol kimlik numarası veya numaraları
    };
    try {
      // Kullanıcı kaydı için istek atılıyor.
      const userResponse = await fetch(
        `http://${AYD_API_IP}:${AYD_API_PORT}/api/v1.1/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${appToken}`, // Alınan token ile Authorization header oluşturuluyor.
          },
          body: JSON.stringify(data),
        }
      );

      if (!userResponse.ok) {
        showError();
      } else {
        showSuccess();
      }
    } catch (error) {
      console.error("Kullanıcı kaydı sırasında bir hata oluştu:", error);
    }
  };
  const handleAddDriverButtonClick = async () => {
    // Cep telefonu numarasından sadece rakamları alarak formattedGSM'e atama yapılıyor.

    try {
      // Kullanıcı kaydı için istek atılıyor.
      const userResponse = await fetch(
        `http://${AYD_API_IP}:${AYD_API_PORT}/api/v1.1/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${appToken}`, // Alınan token ile Authorization header oluşturuluyor.
          },
          body: JSON.stringify({
            user: {
              id: selectedDriver,
            },
          }), // Kullanıcı kaydı için oluşturulan data nesnesi gönderiliyor.
        }
      );

      if (!userResponse.ok) {
        showError();
      } else {
        showSuccess();
        setTimeout(() => {}, 1000);
      }
    } catch (error) {
      console.error("Kullanıcı kaydı sırasında bir hata oluştu:", error);
    }
  };

  const location = useLocation();

  const roles = [
    { id: ["KV_DRIVER"], label: "KAPTAN KULLANIM ROLÜ" },
    { id: ["KV_EMPLOYEE"], label: "PERSONEL KULLANIM ROLÜ" },
    { id: ["KV_OFFICER"], label: "KORDİNATÖR KULLANIM ROLÜ" },
    { id: ["KV_READONLY"], label: "YANLIZCA GÖRÜNTÜLEME" },
    { id: ["KV_ROOT"], label: "YETKİLİ KULLANIM ROLÜ" },
    { id: ["KV_SUPERUSER"], label: "SÜPER YETKİLİ" },
    { id: ["SHARED_READONLY"], label: "(S) YANLIZCA GÖRÜNTÜLEME" },
    { id: ["SHARED_ROOT"], label: "(S) YETKİLİ KULLANIM ROLÜ" },
    { id: ["SHARED_SUPERUSER"], label: "(S) SÜPER YETKİLİ" },
  ];
  const handleRoleChange = async (e) => {
    setUserRole(e.value);
  };

  const userTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-users mr-2" />
        {options.titleElement}
      </button>
    );
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const tokenResponse = await fetch(
          `http://${API_IP}:${API_PORT}/api/token`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              username: "3234548",
              password: "3234548",
            }),
          }
        );
        if (!tokenResponse.ok) {
          throw new Error("Token alınırken bir hata oluştu");
        }

        const tokenData = await tokenResponse.json();
        setAppToken(tokenData.data.token);
      } catch (error) {
        console.error("API'den veri alınırken bir hata oluştu:", error);
      }
    };

    fetchData();
  }, []);

  const driverTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-user mr-2" />
        {options.titleElement}
      </button>
    );
  };
  const vehicleTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-truck mr-2" />
        {options.titleElement}
      </button>
    );
  };
  const deviceTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-tablet mr-2" />
        {options.titleElement}
      </button>
    );
  };
  const deviceVehicleRelationTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-arrow-right-arrow-left mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const seatSchemaTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-sitemap mr-2" />
        {options.titleElement}
      </button>
    );
  };

  const transportationSchemaTab = (options) => {
    return (
      <button
        type="button"
        onClick={options.onClick}
        className={options.className}
      >
        <i className="pi pi-map mr-2" />
        {options.titleElement}
      </button>
    );
  };

  return (
    <div className="card py-4 px-36">
      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>
      <Toast ref={toast} />

      <TabView>
        <TabPanel
          header="Kullanıcı"
          headerTemplate={userTab}
          style={{ border: "0px" }}
        >
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />

            <div className="flex flex-col items-center z-1">
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="username" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Adı :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <i className="pi pi-user" />
                  <InputText
                    className="mt-1 w-full"
                    id="userfirstname"
                    value={userFirstName}
                    onChange={(event) => setUserFirstName(event.target.value)}
                  />
                </span>
              </div>

              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="username" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Soyadı :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <i className="pi pi-user" />
                  <InputText
                    className="mt-1 w-full"
                    id="userlastname"
                    onChange={(event) => setUserLastName(event.target.value)}
                    value={userLastName}
                  />
                </span>
              </div>
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="userid" className="text-blue-900 w-40 pr-2">
                  Kullanıcı ID :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <i className="pi pi-id-card" />
                  <InputText
                    onChange={(event) => setUserYerlemId(event.target.value)}
                    className="mt-1 w-full"
                    id="username"
                    value={userYerlemId}
                  />
                </span>
              </div>
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="usermail" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Mail :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <div className="p-inputgroup flex-1 flex flex-row items-center">
                    <InputText
                      placeholder="Email"
                      value={userEmail}
                      onChange={(event) => setUserEmail(event.target.value)}
                    />
                    <span className="p-inputgroup-addon">@yerlem.com</span>
                  </div>
                </span>
              </div>
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="usergsm" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Telefon :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <i className="pi pi-phone" />
                  <InputMask
                    onChange={(event) => setUserGSM(event.target.value)}
                    className="mt-1 w-full"
                    value={userGSM}
                    id="phone"
                    mask="(999) 999-9999"
                    placeholder="(999) 999-9999"
                  ></InputMask>
                </span>
              </div>
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="userrole" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Rolü :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <i className="pi pi-phone" />
                  <Dropdown
                    value={userRole}
                    options={roles.map((item) => ({
                      label: item.label,
                      value: item.id, // Veya item.value, değere bağlı olarak ne kullanılıyorsa ona göre ayarlayın
                    }))}
                    className="w-full"
                    optionLabel="label"
                    placeholder="Kullanıcı Rolü Seçiniz"
                    onChange={handleRoleChange}
                  />
                </span>
              </div>
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="password" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Şifresi :
                </label>
                <div className="flex w-80">
                  <Password
                    onChange={(event) => setUserPassword(event.target.value)}
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                    feedback={false}
                  />
                </div>
              </div>
              <div className="flex flex-row items-center mx-2 mb-4">
                <label
                  htmlFor="usertwofactor"
                  className="text-blue-900 w-40 pr-2"
                >
                  Two Factor :
                </label>
                <span className="p-input-icon-left flex  items-center  justify-around w-80">
                  <InputSwitch
                    checked={userTwoFactorAuthentication}
                    onChange={(e) => setUserTwoFactorAuthentication(e.value)} 
                  />
                  <Button
                    label="Kullanıcıyı Kaydet"
                    severity="info"
                    icon="pi pi-save"
                    onClick={handleAddUserButtonClick}
                    iconPos="right"
                  />
                </span>
              </div>
              <div className="flex flex-row items-center bg-red-900 mx-2 mb-4"></div>
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Sürücü" headerTemplate={driverTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
            <div className="flex flex-col items-center z-1">
              <div className="flex flex-row items-center mx-2 mb-4">
                <label htmlFor="userrole" className="text-blue-900 w-40 pr-2">
                  Kullanıcı Rolü :
                </label>
                <span className="p-input-icon-left flex w-80">
                  <Dropdown
                    optionLabel="name"
                    placeholder="Sürücü Seçiniz"
                    filter
                    className="w-full "
                  />
                </span>
              </div>

              <div className="flex flex-row items-center mx-2 mb-4">
                <span className="p-input-icon-left flex  items-center  justify-around w-80">
                  <Button
                    label="Kullanıcıyı Kaydet"
                    className="w-full"
                    severity="info"
                    icon="pi pi-save"
                    onClick={handleAddUserButtonClick}
                    iconPos="right"
                  />
                </span>
              </div>
              <div className="flex flex-row items-center bg-red-900 mx-2 mb-4"></div>
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Araç" headerTemplate={vehicleTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
          </div>
        </TabPanel>
        <TabPanel header="Aygıt" headerTemplate={deviceTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
          </div>
        </TabPanel>
        <TabPanel
          header="Aygıt Araç Eşleşmesi"
          headerTemplate={deviceVehicleRelationTab}
        >
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
          </div>
        </TabPanel>
        <TabPanel header="Oturma Şeması" headerTemplate={seatSchemaTab}>
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
          </div>
        </TabPanel>
        <TabPanel
          header="Ulaşım Şeması"
          headerTemplate={transportationSchemaTab}
        >
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
          </div>
        </TabPanel>
        <TabPanel
          header="Kullanıcılar"
          headerTemplate={transportationSchemaTab}
        >
          <div className="relative h-screen bg-cyan-50 rounded-3xl flex flex-col justify-center items-center">
            <img src={yerlembg} className="absolute h-full object-cover z-0 " />
          </div>
        </TabPanel>
      </TabView>

    </div>
  );
}
